export const integrationsDirectCdiAwsAccountId = "/integrations/direct/cdi/aws-account-id";
